import React, {PureComponent} from 'react';

import LandingFreelance from './LandingFreelanceUniverse.jsx';

import header from './images/header-generic-hr.png';

const metaDescription = "Accédez à des missions pour consultants ressources humaines: gestion paie, SIRH, responsable administratif et comptable, RH droit social et manager de transition.";
const metaTitle = "Twineeds | Nos missions pour Consultants et Experts RH";

export default class LandingFreelanceHr extends PureComponent {
  render() {
    return (
      <LandingFreelance
        headerImg={header.src}
        headerImgAlt="PC et portable montrant un site d'intermédiation pour consultants freelances et entreprise"
        metaDescription={metaDescription}
        metaOgDescription={metaDescription}
        metaTitle={metaTitle}
        metaOgTitle={metaTitle}
        sectorText="des ressources humaines"
        title="Missions pour professionnels des Ressources Humaines"
        universeCode="hr"
      />
    )
  }
}
